import {
  isProductPickerDivider,
  ProductPickerItem,
} from '../PlanPurchaseFlow/PickProductStep/getPickerItems';

/**
 * Filters picker items by the selected tab.
 * Includes product items and dividers that match the tab (dividers only after at least one item).
 */
export const filterItemsByTab = (
  items: ProductPickerItem[],
  selectedTab: string
): ProductPickerItem[] =>
  items.reduce<ProductPickerItem[]>((acc, item) => {
    if (isProductPickerDivider(item)) {
      const matchesTab = item.tabId === undefined || item.tabId === selectedTab;

      if (matchesTab && acc.length > 0) {
        return [...acc, item];
      }

      return acc;
    }

    if (item.tabId === selectedTab) {
      return [...acc, item];
    }

    return acc;
  }, []);
